










































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import BaseContainer from '@/components/BaseContainer.vue';
import StatusPanel from '@/components/StatusPanel.vue';
import BaseInfoPanel from '@/components/BaseInfoPanel.vue';
import { Inquiry, yun } from '@/http';
import ButtonPanel from '@/components/ButtonPanel.vue';
import CspDialog from '@/components/CspDialog.vue';
import { enums } from '@/common/enums';
import StatusPanelorder from '@/components/StatusPanelorder.vue';
import { PaginationPanel } from '@/components';

import orderDetailcc from './orderDetailcc.vue';
import ImagesUpload from '@/components/ImagesUpload.vue';
import { formRules } from '@/common/util/validator';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { default as PageDescribe } from '@/components/PageDescribe.vue';

import publicFunc from '../../common/util/publicFunc';
@Component({
    components: {
        StatusPanelorder,
        orderDetailcc,
        BaseContainer,
        StatusPanel,
        BaseInfoPanel,
        ButtonPanel,
        CspDialog,
        DataPanel,
        ImagesUpload,
        PageDescribe,
        PaginationPanel,
    },
})
export default class InquiryDetail extends Vue {
    public winVisible = false;
    public formDataWin: any = {};
    public goodsUnitType = enums.goodsUnitTypeNum;
    public activeName = 'first';
    public title: string = '在线查看订单信息以及相关的运单信息';
    public cspdiaConfig: any = {
        cspDialogVisible: false,
        title: '询价单终结',
        content: '确认终结询价单？',
    };
    public publicFunc: any = publicFunc;
    public formRules = formRules;
    public id: any = '';
    public name: any = '';
    public detailData: any = {};
    public goodsList: any = [];
    public formData: any = {
        carId: '',
        carCode: '',
        driverId: '',
        driverName: '',
        driverPhone: '',
        carLengthEnumStr: '',
        carLengthEnum: '',
        vehicleTypeEnumStr: '',
        vehicleTypeEnum: '',
        subLoadTime: '',
        goodsList: [
            {
                orderId: '',
                goodsId: '',
                goodsName: '',
                quantity: '',
                unit: '',
                planQuantity: '',
                planGoodsUnit: '',
            },
        ],
        carrierAttList: [
            {
                name: '',
                path: '',
            },
        ],
    };
    public fhdb3: boolean = false;
    public fhdz3: boolean = false;
    public fhds3: boolean = false;
    public wcfhjh3: boolean = false;
    public from: any = '';
    public obj:any = {};
    public async created() {
        let webMenus = JSON.parse(localStorage.getItem('mlssloginAd')).webMenus;
        this.fhdb3 = webMenus.includes('fhdb3');
        this.fhdz3 = webMenus.includes('fhdz3');
        this.fhds3 = webMenus.includes('fhds3');
        this.wcfhjh3 = webMenus.includes('wcfhjh3');
        this.id = this.$route.query.id;
        this.name = this.$route.query.name;
        this.from = this.$route.query.from;
        if(this.$route.query.obj){
            this.obj = JSON.parse(this.$route.query.obj as string);
            console.log('resddd->>',this.obj);
        }
        this.getdd();
        this.listcc();
    }
    public carLengthList: any = [];
    public vehicleTypeList: any = [];
    public async getdd() {
        this.carLengthList = await yun.GetDicList({ typeName: 'carLength' });
        this.vehicleTypeList = await yun.GetDicList({ typeName: 'carType' });
        yun.OrdergetDetaill(this.id).then((res) => {
            this.detailData = res;
        });
    }
    public tableData: any = [];
    handleClick(tab, event) {
        console.log(tab, event);
        if (tab.index == '1') {
        }
    }
    changss() {
        this.$nextTick();
        console.log('tableData', this.tableData);
    }
    carid;
    carName;
    dirvers: any = [];

    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            //给每一行添加不可枚举属性rowIndex来标识当前行
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }
    back() {
        if (this.from) {
            if(this.from=='PaystatementDetails'||this.from=='receivableStatementDetails'){
                  this.$router.back();
            }else if(this.from == 'WayBillDetail'){
                console.log('get-->',this.from);
                this.$router.push({
                    path: '/WayBillDetail',
                    query: {
                        ...this.obj,
                        tab:'first'
                    },
                });
                return
            }
            else{
                this.$router.push(`/${this.from}`);
            }

        } else {
            this.$router.push('/orderManager');
        }
    }
    public dialogConfig: any = {
        title: '终结该运单',
        show: false,
    };
    confirmClose() {
        this.dialogConfig = {
            title: '',
            show: false,
        };
    }
    async confirmOk() {
        this.dialogConfig = {
            show: false,
        };
        if (this.btt == 2) {
            yun.IupdateOrderStatus({ id: this.$route.query.id, orderStatus: 4 }).then(() => {
                this.$message.success('发货计划完成成功');
                this.$router.push('/orderManager');
            });
        }
    }
    public btt: any = 0;
    public ssid: any = '';
    endInquiry() {
        this.ssid = '';
        this.btt = 2;
        this.dialogConfig = {
            title: '完成该发货计划',
            show: true,
        };
        // this.$confirm('确认完成该订单？', '订单完成', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // })
        //     .then(() => {
        //         yun.IupdateOrderStatus({ id: this.$route.query.id, status: 3 }).then(() => {
        //             this.$message.success('订单完成成功');
        //             this.$router.push('/ordermanager');
        //         });
        //     })
        //     .catch(() => {});
    }
    public $refs: {
        pagination1: HTMLFormElement;
        formData: HTMLFormElement;
    };
    public tableData1: any = [];
    public total1: any = 0;
    public loading = false;
    public searchPagin1: any = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public rePagin1 = false;
    async listcc() {
        let res = await yun.pageSimpleList({ orderId: this.$route.query.id, skip: this.searchPagin1.skip, count: this.searchPagin1.count });
        this.tableData1 = res.data;
        this.tableData1 = res.data;
        console.log('res', res);
        let skip = this.searchPagin1.skip;
        this.$refs.pagination1.setPage(this.searchPagin1.currentPage);
        this.tableData1.map((item, index) => {
            item.index = skip++ + 1;
        });
        this.total1 = res.total;
    }
    public async onPaginationChange1(pagin: any) {
        this.searchPagin1 = pagin;
        this.listcc();
    }
    toDetail1(row, type) {
        console.log('row', row);
        if (type == 1) {
            this.$router.push({
                path: '/WayBillDetail',
                query: {
                    types: 'orderDetailcc',
                    id: row.orderList[0].id,
                    name: 'detail',
                    orderCnt: row.orderList.length,
                    //orderId:row.orderList[0].id
                    orderId: row.id,
                    status: row.carrierOrderStatus,
                    tab: 'second',
                },
            });
        } else if (type == 2) {
            this.$router.push({
                path: '/WayBillDetail',
                query: {
                    id: row.id,
                    tab: 'third',
                    orderCnt: row.orderList.length,
                },
            });
        }
    }
    public getcarriageWayColor(val) {
        switch (val) {
            case '待发货':
                return 'dfh';
            case '在途中':
                return 'ztz';
            case '已送达':
                return 'ysd';
            case '已终结':
                return 'yzj';

            default:
                break;
        }
    }
}
